// Angular Files
import {
 Component, EventEmitter, Input, Output
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// Payment Integrations
import { PaymentProcessorProvider } from 'apps/public-portal/src/app/payment-integrations';

// Teller Online Files
import {
    AuthService,
    UserService,
    InboundRedirectService
} from 'apps/public-portal/src/app/core/services';
import {
    isAccountSettingsUrl
} from 'apps/public-portal/src/app/core/utils/account-settings-routes';
import { isRailShowing } from 'apps/public-portal/src/app/core/utils/rail.utils';

// Teller Online Library Files
import {
    TellerOnlineAppService,
    TellerOnlineRailNavigationService,
    TellerOnlineSiteMetadataService
} from 'teller-online-libraries/core';

@Component({
    selector: 'app-header',
    template: `
        <public-header
            [preview]="false"
            [siteTitle]="siteTitle"
            [mobileMenuOpened]="mobileMenuOpened"
            [helpOpened]="helpOpened"
            [cartItemCount]="cartItemCount"
            [cartOpened]="cartOpened"
            [accountMenuOpened]="accountMenuOpened"
            [appService]="appService"
            [siteMetadataService]="siteMetadataService"
            [authService]="authService"
            [userService]="userService"
            [paymentProvider]="paymentProvider"
            [inboundRedirectService]="inboundRedirectService"
            [authenticationEnabled]="siteMetadataService?.authenticationEnabled"
            [menuItems]="siteMetadataService?.menuItems"
            [isCheckoutSuccessPage]="isCheckoutSuccessPage"
            [accountSettingsPage]="accountSettingsPage"
            [railShowing]="railShowing"
            [returnToSenderLabel]="returnToSenderLabel"
            (toggleMobileMenu)="toggleMobileMenu.emit($event)"
            (toggleHelp)="toggleHelp.emit($event)"
            (toggleCart)="toggleCart.emit($event)"
            (toggleAccountMenu)="toggleAccountMenu.emit($event)">
        </public-header>
    `,
    host: {
        class: 'header'
    },
    standalone: false
})
export class HeaderComponent {
    @Output() toggleMobileMenu = new EventEmitter<boolean>();

    @Output() toggleHelp = new EventEmitter<boolean>();

    @Output() toggleCart = new EventEmitter<boolean>();

    @Output() toggleAccountMenu = new EventEmitter<boolean>();

    @Input() siteTitle: string;

    @Input() mobileMenuOpened: boolean = false;

    @Input() helpOpened: boolean = false;

    @Input() cartItemCount: number = 0;

    @Input() cartOpened: boolean = false;

    @Input() accountMenuOpened: boolean = false;

    public returnToSenderLabel: string = 'Cancel Payment';

    public isCheckoutSuccessPage: boolean = false;

    public get accountSettingsPage(): boolean {
        return isAccountSettingsUrl(this.appService.currentUrl);
    }

    public get railShowing(): boolean {
        return isRailShowing(this.railNavigationService, this.appService);
    }

    constructor(
        public appService: TellerOnlineAppService,
        public siteMetadataService: TellerOnlineSiteMetadataService,
        public authService: AuthService,
        public userService: UserService,
        public paymentProvider: PaymentProcessorProvider,
        public inboundRedirectService: InboundRedirectService,
        public router: Router,
        private railNavigationService: TellerOnlineRailNavigationService
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.isCheckoutSuccessPage = event.url.includes('/checkout/success');
                this.returnToSenderLabel = this.isCheckoutSuccessPage
                    ? `Return to ${inboundRedirectService.redirectSourceFriendlyName}`
                    : 'Cancel Payment';
            }
        });
    }
}
